import AdminOptions from './AdminOptions';

export default AdminOptions;
